import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { CacheService  } from './cache.service';


@Injectable()
export class ApiService {
  constructor(public _http: Http) {

  }

 /**
  * whatever domain/feature method name
  * Creates a get request
  */
  get(url: string, options?: any) {
    return this._http.get(url, options)
      .map(res => res.json())
      .catch(this._handleError);
  }

  /**
   * whatever domain/feature method name
   * Creates a post request
   */
  post(url: string, body:any, options?: any){
    if(!options){
      options = {};
      options.headers = new Headers({ 'Content-type' : 'application/json' });
    }

    return this._http.post(url,body,options)
      .map(res => res.json())
      .catch(this._handleError);
  }

  /**
   * whatever domain/feature method name
   * Creates a put request
   */
  put(url: string, body:any, options?: any){
    if(!options){
      options = {};
      options.headers = new Headers({ 'Content-type' : 'application/json' });
    }

    return this._http.put(url,body,options)
      .map(res => res.json())
      .catch(this._handleError);
  }

  delete(url:string){
    return this._http.delete(url);
  }

  private _handleError(err:any){
    console.log('Error: ', err);
    return Observable.throw(err);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/api.service.ts